import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { DashboardTimelineType } from '../../../constants/ComponentTypes';
import { addCommas } from '../../../utils/utils';

const styles = () => ({
  root: {
    padding: '24px 28px',
    boxSizing: 'border-box',
    marginBottom: '22px',
  },

  people: {
    display: 'flex',
    alignItems: 'flex-end',
  },

  company: {
    marginTop: '14px'
  },
});

class StatusOverview extends React.Component {
  getDayBeforeCount = () => {
    const { type, pageInfo } = this.props;

    let count = 0;

    if (pageInfo && pageInfo.hasOwnProperty('daily_summaries')) {
      if (type === DashboardTimelineType.APPOINTMENT.value && pageInfo.daily_summaries["appointment_count"]) {
        count = pageInfo.daily_summaries["appointment_count"];
      } else if (type === DashboardTimelineType.CLOSE.value && pageInfo.daily_summaries["close_count"]) {
        count = pageInfo.daily_summaries["close_count"];
      } else if (type === DashboardTimelineType.APPROACH_NG.value && pageInfo.daily_summaries["approach_ng_count"]) {
        count = pageInfo.daily_summaries["approach_ng_count"];
      } else if (type === DashboardTimelineType.QR_CODE_REACTION.value && pageInfo.daily_summaries["qr_code_reaction_count"]) {
        count = pageInfo.daily_summaries["qr_code_reaction_count"];
      } else if (type === DashboardTimelineType.NON_CONNECT.value && pageInfo.daily_summaries["non_connect_count"]) {
        count = pageInfo.daily_summaries["non_connect_count"];
      } else if (type === DashboardTimelineType.DECLINED.value && pageInfo.daily_summaries["declined_count"]) {
        count = pageInfo.daily_summaries["declined_count"];
      } else if (type === DashboardTimelineType.CONNECT.value && pageInfo.daily_summaries["connect_count"]) {
        count = pageInfo.daily_summaries["connect_count"];
      } else if (type === DashboardTimelineType.SENT_DOCUMENT.value && pageInfo.daily_summaries["sent_document_count"]) {
        count = pageInfo.daily_summaries["sent_document_count"];
      } else if (type === DashboardTimelineType.LEAD_NOTE.value && pageInfo.daily_summaries["lead_note_count"]) {
        count = pageInfo.daily_summaries["lead_note_count"];
      } else if (type === DashboardTimelineType.APPROACH.value && pageInfo.daily_summaries["approach_count"]) {
        count = pageInfo.daily_summaries["approach_count"];
      }
    }

    return count;
  }

  render() {
    const { classes, pageInfo, type } = this.props;
    const dayBeforeCount = this.getDayBeforeCount();
    const totalCount = pageInfo && pageInfo.hasOwnProperty('total') ? pageInfo.total : 0;
    let color = '#1A40FF';
    let backgroundColor = '#F2F4FF';
    if ((type || type === DashboardTimelineType.QR_CODE_REACTION.value) && type !== 'read_note') {
      const targetType = Object.values(DashboardTimelineType).find(TimelineType => TimelineType.value === type);
      color = targetType.color;
      backgroundColor = targetType.backgroundColor;
    }

    return (
      <div className={classes.root} style={{ color: color, backgroundColor: backgroundColor }}>
        <div className={classes.people}>
          <Typography style={{ fontSize: '32px', color: color }}>
            {this.props.isLoading ? '-' : pageInfo && pageInfo.hasOwnProperty('total') ? addCommas(pageInfo.total) : '-'}人
          </Typography>
          <Typography style={{ fontSize: '14px', color: color, marginLeft: "10px", marginBottom: "6px" }}>
            （前日比  {this.props.isLoading ? '-' : ((totalCount - dayBeforeCount) > 0 ? "+" : "") + (totalCount - dayBeforeCount)}）
          </Typography>
        </div>
        <div className={classes.company}>
          <Typography variant="body2" style={{ color: color }}>
            企業数: {this.props.isLoading ? '-' : pageInfo && pageInfo.hasOwnProperty('corporation_count') ? addCommas(pageInfo.corporation_count) : '- '}社
          </Typography>
        </div>
      </div>
    )
  }
}

StatusOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageInfo: PropTypes.object,
};

export default withStyles(styles)(StatusOverview);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/parts/StatusOverview.jsx